module.exports = __webpack_public_path__ + "img/3df1061c2796ce2fa5f5aee4cb0c7f58.png";